import Vue from "vue";
import Router from "vue-router";
import Start from "@/components/steps/NewAccount.vue";
import Login from "@/components/steps/Login.vue";
import PersonalData from "@/components/steps/PersonalData.vue";
import DocumentSelection from "@/components/steps/DocumentSelection.vue";
import PhoneNumber from "@/components/steps/PhoneNumber.vue";
import ConfirmEmail from "@/components/steps/ConfirmEmail.vue";
import Currency from "@/components/steps/Currency.vue";
import ReturnToDesktop from "@/components/steps/ReturnToDesktop.vue";
import AddressDetails from "@/components/steps/AddressDetails.vue";
import DeclarationAcceptance from "@/components/steps/DeclarationAcceptance.vue";
import ClientZoneLogin from "@/components/steps/ClientZoneLogin.vue";
import WaitingForPicture from "@/components/steps/WaitingForPicture.vue";
import ConfirmPhone from "@/components/steps/ConfirmPhone.vue";
import SelectMobileDesktop from "@/components/steps/SelectMobileDesktop.vue";
import TaxResidence from "@/components/steps/TaxResidence.vue";
import SelectRegistrationMethod from "@/components/steps/DataUploadChoice.vue";
import OnboardingDenied from "@/components/steps/OnboardingDenied.vue";
import UploadFailed from "@/components/steps/UploadFailed.vue";
import UploadSucceeded from "@/components/steps/UploadSucceeded.vue";
import UploadDocumentFront from "@/components/steps/UploadDocumentFront.vue";
import RiskAssessment from "@/components/steps/RiskAssessment.vue";
import ThxPageAccountOpen from "@/components/steps/AccountOpen.vue"
import i18n from "@/i18n";
import store from './store'
import { UtilityHelper } from "@/helpers/UtilityHelper";
import UploadException from "./components/steps/UploadException.vue";

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: `${UtilityHelper.getBaseByLocale()}`,
  routes: [
    {
      path: "/login",
      name: "restart",
      component: Login,
    },
    {
      path: "/login",
      name: "newLogin",
      component: Login,
    },
    {
      path: "/",
      name: "newAccount",
      component: Start,
    },
    {
      path: "*",
      name: "NotFound",
      component: Start,
    },
    {
      path: "/select-registration-method",
      name: "dataUploadChoice",
      component: SelectRegistrationMethod,
    },
    {
      path: "/select-device",
      name: "mobileDesktopChoice",
      component: SelectMobileDesktop,
    },
    {
      path: "/document-selection",
      name: "desktopDocumentChoice",
      component: DocumentSelection,
    },
    {
      path: "/upload-document",
      name: "desktopDocumentUpload",
      component: UploadDocumentFront,
    },
    {
      path: "/upload-failed",
      name: "uploadFailed",
      component: UploadFailed,
    },
    {
      path: "/upload-succeeded",
      name: "uploadSucceeded",
      component: UploadSucceeded,
    },
    {
      path: "/upload-exception",
      name: "uploadException",
      component: UploadException,
    },
    {
      path: "/phone-number",
      name: "mobileSms",
      component: PhoneNumber,
    },
    {
      path: "/confirm-email",
      name: "confirmEmail",
      component: ConfirmEmail,
    },
    {
      path: "/waiting-for-mobile",
      name: "mobileDesktopIsCompleted",
      component: WaitingForPicture,
    }, // Mobile route started, desktop waits until mobile is completed

    // ---------------------------------------------------
    // <editor-fold desc="ON MOBILE PHONE (MOBILE ROUTE)">
    // ---------------------------------------------------
    {
      path: "/document-selection",
      name: "mobileDocumentChoice",
      component: DocumentSelection,
    },
    {
      path: "/upload-document",
      name: "mobileDocumentUpload",
      component: UploadDocumentFront,
    },
    {
      path: "/return-to-desktop",
      name: "mobileReturnToDesktop",
      component: ReturnToDesktop,
    },

    // ---------------------------------------------------
    // </editor-fold>
    // ---------------------------------------------------

    {
      path: "/personal-data",
      name: "personalDataConfirm",
      component: PersonalData,
    },
    {
      path: "/confirm-phone",
      name: "desktopSms",
      component: ConfirmPhone,
    },
    {
      path: "/residence-details",
      name: "addressDetails",
      component: AddressDetails,
    },
    {
      path: "/tax-residence",
      name: "taxOfficeDetails",
      component: TaxResidence,
    },
    {
      path: "/currency",
      name: "currencyChoice",
      component: Currency,
    },
    {
      path: "/declaration-acceptance",
      name: "declarationAcceptance",
      component: DeclarationAcceptance,
    },
    {
      path: "/risk-assessment",
      name: "riskAssessment",
      component: RiskAssessment,
    },

    // -----------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------

    {
      path: "/client-zone-login",
      name: "errorsReport",
      component: ClientZoneLogin,
    },
    {
      path: "/denied",
      name: "onboardingDenied",
      component: OnboardingDenied,
    },
    {
      path: "/account-open",
      name: "accountOpen",
      component: ThxPageAccountOpen,
    },

  ],
});

router.afterEach(async (to) => {
  const step = to.name; 
  store.commit('SET_ROUTE', step);
  Vue.nextTick(() => {
    const interval = setInterval(() => {
      if (store.state.isLocked === false) {
        window.scrollTo(0, 0)
        clearInterval(interval)
      }
    }, 50);
  })
  if (store.state.analyticsService) {
    store.state.analyticsService.sendStepEvent(step);
  } else {

    let i: number | undefined;

    i = window.setInterval(() => {
      if (store.state.analyticsService) {
        store.state.analyticsService.sendStepEvent(step);
        clearInterval(i)
      }
    }, 500);
  }
})

export default router;
